import React from "react";
import { APP_NAME } from "../../../../../config";

function Footer({ ...props }) {
  return (
    <footer className="container footer">
      <div className="h-100 d-flex align-items-center">
        <span>
          {APP_NAME} &copy; {1900 + new Date().getYear()}{" "}
        </span>
      </div>
    </footer>
  );
}

export default Footer;
